export default "__VITE_ASSET__BOnfdd6V__"